import { hot } from 'react-hot-loader/root';

import 'src/v2_assets/css/global.scss';

import MainQuery from './MainQuery';

export default hot(MainQuery);
